
import Language from './lang'

export default  new Language({
    'The Finder 后台': 'The Finder Administration',
    'The Finder：追尋者': 'The Finder - เหลียงซานข้าเจ๋งสุด',
    '《會員服務條款》': '《นโยบายการให้บริการ》',
    '交易失敗': 'ทำธุรกรรมล้มเหลว',
    '会员账号': 'บัญชีสมาชิก',
    '会员资料': 'ข้อมูลสมาชิก',
    '信箱已被占用': 'อีเมลถูกใช้งานแล้ว',
    '信箱格式有誤': 'รูปแบบอีเมลผิด',
    '修改手機號需要同時驗證新舊手機': 'เปลี่ยนเบอร์มือถือต้องยืนยันทั้งเบอร์เก่าและใหม่',
    '修改郵箱需要同時驗證新舊郵箱': 'เปลี่ยนเบอร์มือถือต้องยืนยันทั้งอีเมลเก่าและใหม่',
    '储值': 'เติมเงิน',
    '储值/购买': 'เติมเงิน/ซื้อ',
    '儲值': 'เติมเงิน',
    '儲值/購買': 'เติมเงิน/ซื้อ',
    '全服通用': 'การบริการเต็มรูปแบบ',
    '兩次輸入的密碼並不相符，請重新輸入': 'กรอกรหัส 2 ครั้งไม่ถูกต้อง กรุณากรอกใหม่',
    '公告': 'ประกาศ',
    '其他': 'อื่น ๆ',
    '创建时间': 'เวลาที่สร้าง',
    '区号': 'เลขเซิร์ฟเวอร์',
    '区号：%s': 'เลขเซิร์ฟเวอร์: %s',
    '取消': 'ยกเลิก',
    '只需輸入0後面數字': 'กรอกตัวเลขหลัง 0',
    '台湾': 'ไต้หวัน',
    '同意接受 Pangsky 消息及廣告訊息': 'ยอมรับข่าวสารและโฆษณาจาก Pangsky',
    '問題': 'คำถาม',
    '图片分享区': 'พื้นที่แชร์รูป',
    '安装/执行': 'ติดตั้ง/ดำเนินการ',
    '安装执行': 'ดำเนินการติดตั้ง',
    '安裝/執行': 'ติดตั้ง/ดำเนินการ',
    '密码': 'รหัส',
    '密码，md5 以后': 'รหัส หลัง md5',
    '密碼': 'รหัส',
    '密碼最少 8 個字元': 'รหัสผ่านอย่างน้อย 8 ตัว',
    '密碼長度最少為 8 字元': 'รหัสผ่านอย่างน้อย 8 ตัว',
    '封号开始时间': 'เวลาเริ่มหัวข้อ',
    '封号类型': 'ประเภทหัวข้อ',
    '封号类型：%s': 'ประเภทหัวข้อ: %s',
    '封号结束时间': 'เวลาสิ้นสุดหัวข้อ',
    '封號記錄': 'ประวัติหัวข้อ',
    '已付': 'ชำระแล้ว',
    '已删除': 'ลบแล้ว',
    '已取消': 'ยกเลิกแล้ว',
    '已处理': 'จัดการแล้ว',
    '已支付': 'ชำระแล้ว',
    '帳號不存在': 'ไม่มีบัญชีนี้อยู่',
    '帳號和信箱不匹配': 'บัญชีกับอีเมลไม่ตรงกัน',
    '帳號和手機號不匹配': 'บัญชีกับเบอร์มือถือไม่ตรงกัน',
    '帳號已被占用': 'บัญชีถูกใช้งานแล้ว',
    '建議': 'ข้อเสนอแนะ',
    '建议': 'ข้อเสนอแนะ',
    '开发公司游戏安保Key': 'คีย์รักษาความปลอดภัยผู้พัฒนาเกม',
    '开发公司游戏安保账号': 'บัญชีรักษาความปลอดภัยผู้พัฒนาเกม',
    '待处理': 'รอจัดการ',
    '您的帳號已被封，如有疑問請聯系客服': 'บัญชีของคุณถูกปิด หากมีข้อสงสัย กรุณาติดต่อฝ่ายบริการลูกค้า',
    '您需年滿12歲始得使用本遊戲。': 'อายุ 12 ปีขึ้นไปจึงจะเล่นเกมนี้ได้',
    '手机': 'มือถือ',
    '手机号': 'เบอร์มือถือ',
    '手机是否接受广告': 'ต้องการรับโฆษณาทางเบอร์มือถือหรือไม่',
    '手機號已被占用': 'เบอร์มือถือถูกใช้งานแล้ว',
    '手機號碼不正確，請重新輸入': 'เบอร์มือถือไม่ถูกต้อง กรุณากรอกใหม่',
    '推荐': 'แนะนำ',
    '支付中': 'กำลังชำระ',
    '攻略讨论区': 'พื้นที่พูดคุยกลยุทธ์',
    '新建': 'สร้าง',
    '新手指南': 'คู่มือมือใหม่',
    '昵称是否可修改': 'ต้องการเปลี่ยนชื่อเล่นหรือไม่',
    '昵称，初始自动生成': 'สร้างชื่อเล่นอัตโนมัติตอนเริ่มต้น',
    '普通': 'ทั่วไป',
    '更新': 'อัพเดท',
    '更新时间': 'เวลาอัพเดท',
    '會員條款': 'เงื่อนไขการเป็นสมาชิก',
    '會員資料': 'ข้อมูลสมาชิก',
    '會員賬號': 'บัญชีสมาชิก',
    '未付': 'ยังไม่ชำระ',
    '未验证': 'ยังไม่ยืนยัน',
    '本遊戲依據遊戲軟體分級管理辦法分類為輔12級。': 'เกมแบ่งวิธีจัดการเป็น 12 ระดับ ตามหมวดหมู่',
    '本遊戲部分內容需要另支付費用。': 'ส่วนหนึ่งของเกมมีค่าใช้จ่ายเพิ่มเติม',
    '检举': 'รายงาน',
    '正常': 'ปกติ',
    '注册': 'สมัคร',
    '活动名称': 'ชื่อกิจกรรม',
    '活动激活码': 'รหัสใช้งานกิจกรรม',
    '活动类型': 'ประเภทกิจกรรม',
    '活動': 'กิจกรรม',
    '游戏': 'เกม',
    '游戏使用': 'การเล่นเกม',
    '游戏名字': 'ชื่อเกม',
    '游戏地图': 'แผนที่เกม',
    '游戏问题': 'ปัญหาเกม',
    '澳门': 'มาเก๊า',
    '点数': 'พอยต์',
    '特色地图': 'แผนที่เฉพาะ',
    '状态': 'สถานะ',
    '状态：%s': 'สถานะ: %s',
    '獲取驗證碼': 'รับรหัสยืนยัน',
    '玩家讨论区': 'พื้นที่พูดคุยผู้เล่น',
    '用戶': 'ผู้ใช้',
    '當前手機號碼已註冊': 'สมัครด้วยเบอร์มือถือปัจจุบันแล้ว',
    '當前手機號與已有手機號衝突，請自訂帳號': 'เบอร์มือถือปัจจุบันไม่ตรงกับเบอร์ที่มีอยู่ กรุณาตั้งค่าบัญชี',
    '登录 IP': 'IP ล็อกอิน',
    '登录失败': 'ล็อกอินล้มเหลว',
    '登录成功': 'ล็อกอินสำเร็จ',
    '登录端': 'ล็อกอิน',
    '登录端%s': 'ล็อกอิน%s',
    '發送成功': 'ส่งแล้ว',
    '盐': 'เกลือ',
    '真实姓名': 'ชื่อสกุลจริง',
    '確認密碼': 'ยืนยันรหัส',
    '禁用': 'แบน',
    '等待': 'รอสักครู่',
    '累积点数': 'สะสมพอยต์',
    '编辑电话': 'แก้ไขเบอร์มือถือ',
    '编辑邮箱': 'แก้ไขอีเมล',
    '聊天': 'พูดคุย',
    '自訂帳號長度最多為 32 字元': 'บัญชีที่ตั้งค่ายาวสูงสุด 32 ตัว',
    '自訂帳號需為英文字母和數字的組合，且第一個字元必須為英文，英文及數字必須為半形': 'บัญชีที่ตั้งค่าควรมีตัวอักษรภาษาอังกฤษและตัวเลขผสมกัน อักษรตัวแรกต้องเป็นภาษาอังกฤษ ตัวอักษรและตัวเลขต้องติดกัน',
    '舊信箱與用戶信箱不一致': 'อีเมลเก่ากับอีเมลผู้ใช้ไม่ตรงกัน',
    '舊密碼不正確': 'รหัสเก่าไม่ถูกต้อง',
    '舊手機號與用戶手機不一致': 'เบอร์มือถือเก่ากับเบอร์ผู้ใช้ไม่ตรงกัน',
    '装备技能': 'ใส่สกิล',
    '裝備技能': 'ใส่สกิล',
    '视频': 'วีดีโอ',
    '請勾選同意接受條款': 'กรุณายอมรับเงื่อนไข',
    '請確認密碼': 'กรุณายืนยันรหัส',
    '請註意遊戲時間，切勿沉迷或不當模仿。': 'อย่าเล่นเกมเพลินจนลืมเวลากันนะคะ',
    '請輸入': 'กรุณากรอก',
    '請輸入信箱': 'กรุณากรอกอีเมล',
    '請輸入密碼': 'กรุณากรอกรหัส',
    '請輸入帳號': 'กรุณากรอกบัญชี',
    '請輸入手機號碼': 'กรุณากรอกเบอร์มือถือ',
    '請輸入正確帳號': 'กรุณากรอกบัญชีที่ถูกต้อง',
    '請輸入身份證號': 'กรุณากรอกหมายเลขบัตรประชาชน',
    '請輸入驗證碼': 'กรุณากรอกรหัสยืนยัน',
    '账号': 'บัญชี',
    '身份證號格式有誤': 'กรอกหมายเลขบัตรประชาชนผิด',
    '身份证号': 'หมายเลขบัตรประชาชน',
    '輸入的Email已被註冊使用': 'อีเมลถูกใช้งานแล้ว',
    '輸入驗證碼': 'กรอกรหัสยืนยัน',
    '运营': 'ดำเนินการ',
    '进阶攻略': 'กลยุทธ์ขั้นสูง',
    '追加回复': 'ตอบกลับเพิ่มเติม',
    '進階攻略': 'กลยุทธ์ขั้นสูง',
    '遊戲': 'เกม',
    '遊戲使用': 'การเล่นเกม',
    '遊戲問題': 'ปัญหาเกม',
    '遊戲地圖': 'แผนที่เกม',
    '運營': 'ดำเนินการ',
    '邮箱': 'อีเมล',
    '邮箱地址': 'ที่อยู่อีเมล',
    '邮箱是否接受广告': 'ต้องการรับโฆษณาทางอีเมลหรือไม่',
    '重置密码': 'รีเซ็ตรหัส',
    '门户': 'เว็บไซต์',
    '问题': 'คำถาม',
    '首頁': 'หน้าหลัก',
    '香港': 'ฮ่องกง',
    '驗證碼': 'รหัสยืนยัน',
    '驗證碼不正確或已過期，請重新獲取驗證碼': 'รหัสไม่ถูกต้องหรือหมดอายุแล้ว กรุณาลองใหม่',
    '正式名稱：The Finder：追尋者': 'ชื่อเกม：เหลียงซานข้าเจ๋งสุด',
    '價格：免費含付費': 'มูลค่า：ไม่มีค่าใช้จ่าย',
    '項目類型：MMORPG': 'ประเภท：MMORPG',
    '動作環境：iOS/Android': 'ระบบปฏิบัติการ：Android',
    '活動時間為：即日起至遊戲禮包領取完截至；': 'ระยะเวลากิจกรรม: ตอนนี้ไปจนถึงได้รับแพ็ครางวัล',
    '每個facebook帳號及手機號碼僅限參加一次預約活動，每項獎勵僅限領取一次；': 'บัญชี Facebook และเบอร์มือถือ ทุกช่องทางจำกัดการเข้าร่วมและรับรางวัล 1 ครั้งเท่านั้น',
    '遊戲相關之獎勵序號，每個遊戲帳號僅限兌換一次，可於遊戲正式上線後遊戲内兌換；': 'โค้ดรางวัลของเกม สามารถแลกได้เพียงครั้งเดียว แลกในเกมได้หลังจาก OBT',
    '如欲查詢獎勵序號，可於頁面上方輸入註冊的帳號密碼，並點擊查看獎勵，進行查詢；': 'หากต้องการตรวจสอบโค้ดรางวัล คุณสามารถล็อกอิน บัญชีที่ลงทะเบียนที่ด้านบนและดูรางวัล',
    '如個人資料輸入錯誤導致獎勵無法正確發送，恕不補發；': 'หากไม่ได้รับรางวัล เนื่องจากป้อนข้อมูลส่วนตัวผิด จะไม่มีสิทธิ์กรอกใหม่',
    '邀請好友獎項【王者分享禮包】將於活動結束後7日内隨機抽出，得獎名單將公布於遊戲官方粉絲團，並官網邀請好友欄目通知得獎者，請隨時留意粉絲頁以及官網訊息；': 'รางวัลเชิญเพื่อน [แพ็คแชร์พิเศษ] จะถูกสุ่มภายใน 7 วันหลังจากสิ้นสุดกิจกรรม รายชื่อผู้รับรางวัล จะประกาศใน FB และกลุ่มอย่างเป็นทางการ โปรดติดตามดูหน้าแฟนเพจและเว็บไซต์ได้ตลอดเวลา',
    '活動所有獎勵不得轉讓、折抵現金或其它等值商品，若拒絕領取視同放棄資格；': 'รางวัลทั้งหมด ไม่สามารถโอนสิทธิ์ เปลี่ยนเป็นเงินเสิน หรือสินค้าอื่นได้ หากปฏิเสธที่จะรับ ถือว่าคุณได้สละสิทธิ์',
    '為處理活動獎勵發送與其它相關業務，得獎者相關個人資料將提供給獎勵發送相關單位使用；': 'รางวัลกิจกรรมและอื่น ๆ ที่เกี่ยวข้อง ข้อมูลส่วนบุคคลของผู้ชนะจะถูกส่งไปยังหน่วยงานที่เกี่ยวข้องเพื่อเก็บรักษาข้อมูล',
    '如有發現使用不當或非法手段參與活動，官方有權取消該玩家及所有相關帳號之得獎資格；': 'หากพบว่ามีการใช้วิธีการที่ไม่เหมาะสมหรือผิดกฎหมายในการเข้าร่วมกิจกรรม แอดมินมีสิทธิ์ตัดสิทธิ์ผู้เล่นและบัญชีทั้งหมดจากการได้รับรางวัล',
    '《The Finder:追尋者》官方將保留對此活動的最終決策、解釋、及更改遊戲規則的權利，如變更内容將於官方網站或粉絲團公告，恕不另行通知。': 'เหลียงซานข้าเจ๋งสุด ขอสงวนสิทธิ์ในการตัดสินใจขั้นสุดท้ายและเปลี่ยนแปลงกฎของเกม การเปลี่ยนแปลงใด ๆ จะถูกประกาศบนเว็บไซต์หรือกลุ่มเพจอย่างเป็นทางการ โดยไม่ต้องแจ้งให้ทราบล่วงหน้า',
    '點擊復制 Facebook 鏈接': 'คัดลอกลิงก์ Facebook',
    '現在註冊': 'ลงทะเบียนตอนนี้',
    '帳號登入': 'ล็อกอิน',
    '登入成功': 'ล็อกอินสำเร็จ',
    '登出': 'ล็อกเอาท์',
    '感謝您對遊戲的支持，我們爲您奉上豐厚的獎勵。': 'ขอบคุณที่สนับสนุน เราจะมอบรางวัลมากมายให้คุณ',
    '目前已成功邀請': 'ตอนนี้เชิญเพื่อนแล้ว',
    '位好友': 'คน',
    '請先註冊登入': 'กรุณาลงทะเบียนก่อน',
    '復制成功': 'คัดลอกสำเร็จ',
    '登出成功': 'ล็อกเอาท์สำเร็จ',
    "驗證碼為 6 位數字": "รหัสยืนยัน 6 ตัวอักษร",
    "条件未达成": "ยังไม่สำเร็จ",
  })